export default __webpack_public_path__ + "static/media/draft.cbc488ec.svg";